import {React, useState } from 'react';
import adminsidebarStyle from './AdminSideBar.module.css';
import { Sidenav, Nav, Modal, Button } from 'rsuite';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate  } from 'react-router-dom';

export default function AdminSideBar() {

  const location = useLocation(); // required for active highlighting
  const navigate = useNavigate ();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // function to detect active menu
  const getActiveKey = () => {
    if (location.pathname.startsWith("/NewSchoolsOrganizationPage") || 
      location.pathname.startsWith("/NewSchoolsOrganizationDetailPage")) return "1";
    if (location.pathname.startsWith("/ActivatedSchoolsOrgPage") || 
      location.pathname.startsWith("/ActivatedSchoolsOrgDetailsPage")) return "2";
    if (location.pathname.startsWith("/EventManagementPage") || 
      location.pathname.startsWith("/EventManagementDetailsPage") ||
       location.pathname.startsWith("/InscriptionReportPage")){ return "3"};
    if (location.pathname.startsWith("/AuthorTrackingPage") ||
       location.pathname.startsWith("/AuthorTrackingDetailsPage") ) return "4";
    if (location.pathname.startsWith("/EventOrdersPage") || location.pathname.startsWith("/EventOrdersPage") 
       || location.pathname.startsWith("/OrderRefundPage")) return "5";
    if (location.pathname.startsWith("/ConsolidatedOrdersPage")) return "6";
    if (location.pathname.startsWith("/OrderRefundPage")) return "7";
    return null;
  };
  
  /*const handleLogout = (e) => {
      e.preventDefault();
     
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.removeItem('isLoggedIn');
      sessionStorage.removeItem('adminToken');
      navigate('/general-login');
    }; */
    const handleLogout = () => {
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.removeItem('isLoggedIn');
      sessionStorage.removeItem('adminToken');
      navigate('/general-login');
    };

  return (
    <Sidenav className={adminsidebarStyle.adminsidebarWrap}>
      <Modal
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        size="xs"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to logout?
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleLogout} appearance="primary" color="red">
            Yes, Logout
          </Button>
          <Button onClick={() => setShowLogoutModal(false)} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Sidenav.Body>
        <Nav activeKey={getActiveKey()} className={adminsidebarStyle.adminsidebarInner}>

          {/* 1. New Schools / Org */}
          <Nav.Item
            eventKey="1"
            as={Link}
            to="/NewSchoolsOrganizationPage"
            active={location.pathname.startsWith("/NewSchoolsOrganizationPage") 
                    || location.pathname.startsWith("/NewSchoolsOrganizationDetailPage")}
            className={adminsidebarStyle.adminsidebarItem}
          >
            New Schools/Org
          </Nav.Item>

          {/* 2. Activated Schools */}
          <Nav.Item
            eventKey="2"
            as={Link}
            to="/ActivatedSchoolsOrgPage"
            active={location.pathname.startsWith("/ActivatedSchoolsOrgPage")
                    || location.pathname.startsWith("/ActivatedSchoolsOrgDetailsPage")}
            className={adminsidebarStyle.adminsidebarItem}
          >
            Activated Schools/Org
          </Nav.Item>

          {/* 3. Event Management */}
          <Nav.Item
            eventKey="3"
            as={Link}
            to="/EventManagementPage"
            active={location.pathname.startsWith("/EventManagementPage")
                    || location.pathname.startsWith("/EventManagementDetailsPage")
                    || location.pathname.startsWith("/InscriptionReportPage")
            }
            className={adminsidebarStyle.adminsidebarItem}
          >
            Event Management
          </Nav.Item>

          {/* 4. Author Tracking */}
          <Nav.Item
            eventKey="4"
            as={Link}
            to="/AuthorTrackingPage"
            active={location.pathname.startsWith("/AuthorTrackingPage")
                    || location.pathname.startsWith("/AuthorTrackingDetailsPage")
            }
            className={adminsidebarStyle.adminsidebarItem}
          >
            Author Tracking
          </Nav.Item>

          {/* 5. Event Orders */}
          <Nav.Item
            eventKey="5"
            as={Link}
            to="/EventOrdersPage"
            active={location.pathname.startsWith("/EventOrdersPage") || location.pathname.startsWith("/OrderRefundPage")}
            className={adminsidebarStyle.adminsidebarItem}
          >
            Event Orders
          </Nav.Item>

          {/* 6. Consolidated Orders */}
          <Nav.Item
            eventKey="6"
            as={Link}
            to="/ConsolidatedOrdersPage"
            active={location.pathname.startsWith("/ConsolidatedOrdersPage")}
            className={adminsidebarStyle.adminsidebarItem}
          >
            Consolidated Orders
          </Nav.Item>

          {/* 6. Logout */}
          <Nav.Item
            eventKey="7"
            
            className={adminsidebarStyle.adminsidebarItem}
             onClick={() => setShowLogoutModal(true)}
          >
            Logout
          </Nav.Item>

        </Nav>
      </Sidenav.Body>
    </Sidenav>
    
  );
}
